import isBoolean from 'lodash/isBoolean'
import isDate from 'lodash/isDate'
import isEmpty from 'lodash/isEmpty'
import isFunction from 'lodash/isFunction'
import isNaN from 'lodash/isNaN'
import isNil from 'lodash/isNil'
import isNumber from 'lodash/isNumber'
import isString from 'lodash/isString'
import trim from 'lodash/trim'

export type CheckValuePresenceOptions = {
	naPattern?: RegExp // customize which strings mean "no value"
	trimWhitespace?: boolean // trim strings before checks
}

const DEFAULTS: Required<CheckValuePresenceOptions> = {
	naPattern: /^(?:n\/?a|n\.?a\.?|na|none|--)$/i,
	trimWhitespace: true,
}

export function checkValuePresence(value: unknown, opts: CheckValuePresenceOptions = {}): boolean {
	const o = { ...DEFAULTS, ...opts }

	// null / undefined
	if (isNil(value)) return false

	// string: trim + N/A variants
	if (isString(value)) {
		const s = o.trimWhitespace ? trim(value) : value
		return s.length > 0 && !o.naPattern.test(s)
	}

	// number: 0 is OK, NaN is not
	if (isNumber(value)) return !isNaN(value)

	// booleans, bigint, symbol, functions are valid
	if (
		isBoolean(value) ||
		isFunction(value) ||
		typeof value === 'bigint' ||
		typeof value === 'symbol'
	) {
		return true
	}

	// checks if date is valid
	if (isDate(value)) return !Number.isNaN(value.getTime())

	if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
		return value.byteLength > 0
	}

	return !isEmpty(value as any)
}
